import { Box, Stepper } from "@mantine/core";
import "./roadmap.css";

export default function Notes() {
  return (
    <Box
      sx={{
        marginTop: 24,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Stepper
        active={3}
        orientation="vertical"
        classNames={{
          stepLabel: "white",
          stepIcon: "stepIcon",
          verticalSeparator: "verticalSeparator",
        }}
      >
        <Stepper.Step label="Support web2 login using web3auth and Ramper" />
        <Stepper.Step label="Support fetching balance, Transfer balance" />
        <Stepper.Step label="Fetch nfts from different collections" />
        <Stepper.Step label="Integrate on-ramp service" />
        <Stepper.Step label="Research on Graph node, indexers" />
        <Stepper.Step label="Create Product Roadmap" />
      </Stepper>
    </Box>
  );
}
